import React from 'react';

interface IconCellProps {
  value?: unknown;
  icon?: React.ReactNode;
  size?: 'small' | 'medium' | 'large';
  render?: () => React.ReactNode;
}

function IconCell({ value, icon, size = 'medium', render }: IconCellProps) {
  if (render) {
    return <>{render()}</>;
  }

  return (
    <div className={`data-cell__icon data-cell__icon--${size}`}>
      {icon || (value as React.ReactNode)}
    </div>
  );
}

export default IconCell;
